import React, { useState } from "react";
import {
  Sparkles,
  Brush,
  Scissors,
  Droplets,
  Hand,
  PenTool,
  UtensilsCrossed,
  ShoppingBag,
  Music3,
  Dumbbell,
  Dog,
  Car,
  CheckCircle,
  Tent,
} from "lucide-react";
import { categories } from "./category";
import ProcessingBar2 from "../../../components/ProcessingBar/ProcessingBar2";

const SelectBusiness = ({ onNext }) => {
  const [selected, setSelected] = useState(null);
  const [showCheck, setShowCheck] = useState(null);
  const [processingLabel, setProcessingLabel] = useState(null);

  const handleSelect = (label) => {
    if (processingLabel) return; // prevent any interaction

    setSelected(label);
    setShowCheck(label);
    setProcessingLabel(null);

    setTimeout(() => {
      setShowCheck(null);
      setProcessingLabel(label);
    }, 1000);

    setTimeout(() => {
      setProcessingLabel(null);
      onNext?.(label);
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-dry flex flex-col items-center justify-start pt-16 px-5">
      <div
        className="text-center mb-8 bg-drylight w-screen py-16"
        data-aos="fade-up"
      >
        <h2 className="text-3xl md:text-4xl font-medium mb-2 text-text px-3">
          What services do you offer?
        </h2>
      </div>

      <div
        className="grid grid-cols-3 md:grid-cols-6 gap-3 max-w-4xl mx-auto"
        data-aos="fade-up"
      >
        {categories.map((item, idx) => {
          const isSelected = selected === item.label;
          const isProcessing = processingLabel === item.label;
          const isShowingCheck = showCheck === item.label;
          const isDisabled = Boolean(processingLabel);

          return (
            <div
              key={idx}
              onClick={() => {
                if (!isDisabled) handleSelect(item.label);
              }}
              className={`group flex flex-col items-center justify-center border rounded-md p-6 text-center transition
                ${
                  isSelected
                    ? "border-redlight bg-redlightlight"
                    : "border-drylight bg-dry"
                }
                ${
                  isDisabled
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer hover:border-redlight hover:bg-redlightlight"
                }`}
            >
              {/* Step 1: Show check + label + icon */}
              {isSelected && isShowingCheck && (
                <>
                  <div className="mb-4">{item.icon}</div>
                  <div className="text-sm font-medium text-dry mb-1 flex items-center">
                    <CheckCircle size={20} className="mr-2 text-dry" />
                    {item.label}
                  </div>
                </>
              )}

              {/* Step 2: Show processing bar */}
              {isProcessing && <ProcessingBar2 />}

              {/* Default view (non-selected) */}
              {!isSelected && (
                <>
                  <div className="mb-4">{item.icon}</div>
                  <div className="text-sm font-medium text-text">
                    {item.label}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectBusiness;
